import { render } from "./NoProfile.vue?vue&type=template&id=6e0b9186"
import script from "./NoProfile.vue?vue&type=script&lang=js"
export * from "./NoProfile.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__